export default {

    methods: {

        /**
         * COMPROBAMOS ACCIÓN
         * Comprobamos si un usuario tiene permiso para una ACCIÓN concreta
         * @param {String} key_name key_name de la acción
         * @return {Boolean} Devuelve si tiene permiso o no
         */
        action(key_name) {
            const item = this.getUserPermissionSet().permission_actions.find( x => x.key_name === key_name );
            return item.value;
        },

        /**
         * COMPROBAMOS OBJETO DE ACCIONES
         * Comprobamos si un usuario tiene permiso para una ACCIÓN concreta en un OBJETO de acciones
         * @param {String} key_name key_name del objecto
         * @param {String} action Acción (add/edit/read/remove)
         * @return {Boolean} Devuelve si tiene permiso o no
         */
        actionObject(key_name, action) {
            const item = this.getUserPermissionSet().permission_objects.find( x => x.key_name === key_name );
            return item.value[action];
        },

        /**
         * Recogemos el permission_set de localstorage
         * @return {Object} Set de permisos del usuario loggeado
         */
        getUserPermissionSet() {
            const { permission_set } = JSON.parse(decodeURIComponent(escape(atob(localStorage.getItem('BOCOUS')))));
            return permission_set;
        }

    }
};
